import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse, Pagination } from 'interfaces/api.interfaces'
import { AlertManual } from 'interfaces/api/alertManual.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

const getAll = async (params: Partial<Pagination>): GetAllResponse<AlertManual> => {
  const { data: response } = await axios.request<GetAllData<AlertManual>>({
    method: 'GET',
    url: endpoints.alertManual.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
    },
  })
  return response
}

const update = async (alertManual: AlertManual): GetOneResponse<AlertManual> => {
  const { data: response } = await axios.request<AlertManual>({
    method: 'PATCH',
    url: endpoints.alertManual.update(alertManual.id),
    data: alertManual,
  })
  return response
}

export const alertManualApi = {
  getAll,
  update,
}
